// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification[data-v-64b88c1b]{position:absolute;top:10px;right:10px;max-width:300px;width:100%;color:#fff;border-radius:6px;padding:10px;opacity:.8}.notification__title[data-v-64b88c1b]{font-weight:700}.notification__message[data-v-64b88c1b]{line-height:20px}.notification_error[data-v-64b88c1b]{background-color:#e54d42}.notification_success[data-v-64b88c1b]{background-color:#68cc89}", ""]);
// Exports
module.exports = exports;
